export const addLessonSidebarHook = () => {
  const sidebar = document.getElementById("sidebar");
  const toggleSidebarButton = document.getElementById("sidebar-toggle-btn");

  if (sidebar && toggleSidebarButton) {
    let hookId;
    let matchedIndents;
    let previousSidebarIndent;
    const maxMatchedIndents = 5;

    const getSidebarIndent = () => parseFloat(getComputedStyle(sidebar).marginLeft);
    const sidebarToggleHook = (id, hide) => {
      if (id === hookId) {
        window.dispatchEvent(new CustomEvent("resize"));

        const currentSidebarIndent = getSidebarIndent();
        matchedIndents = previousSidebarIndent === currentSidebarIndent ? matchedIndents + 1 : 0;
        previousSidebarIndent = currentSidebarIndent;

        const condition = hide
          ? Math.abs(Math.floor(currentSidebarIndent)) !== sidebar.offsetWidth
          : currentSidebarIndent !== 0;
        if (condition && matchedIndents < maxMatchedIndents) {
          requestAnimationFrame(() => sidebarToggleHook(id, hide));
        }
      }
    };

    toggleSidebarButton.addEventListener("click", () => {
      matchedIndents = 0;
      hookId = Math.random();
      previousSidebarIndent = getSidebarIndent();
      sidebarToggleHook(hookId, previousSidebarIndent === 0);
    });
  }
};
